import { DataLayer, calcPrice } from '@grandvisionhq/analytics';
import { Locales } from '@grandvisionhq/state';
import { mapProductToDataLayerProductObject } from './Mappers/ProductMapper.js';

const pushPdpEventToDataLayer = (purchaseType, product, activeSku, currency, productType, pricePerMonth)=>{
    pushEventToDataLayer(purchaseType, product, activeSku, currency, {
        list: 'pdp'
    }, 'gvProductDetail', productType, pricePerMonth);
};
const pushEventToDataLayer = (purchaseType, product, activeSku, currency, actionField, dataEvent, productType, pricePerMonth, eventType, offering)=>{
    const productObject = mapProductToDataLayerProductObject(purchaseType, product, activeSku, // Data in the Data Layer should always be English, therefore hardcoded locale
    Locales['en-GB'], productType, pricePerMonth, offering);
    if (!productObject) {
        return;
    }
    DataLayer.pushEcommerceEvent({
        event: dataEvent,
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                [eventType || 'detail']: {
                    actionField,
                    products: [
                        productObject
                    ]
                }
            }
        }
    });
};
const pushTabClickEvent = (isCLBBTabSelected)=>{
    DataLayer.pushEvent({
        event: 'ContactLensesConfigEvent',
        eventAction: 'click on tab',
        eventLabel: isCLBBTabSelected ? DataLayer.DataLayerTypes.PurchaseType.CLBBSubscription : DataLayer.DataLayerTypes.PurchaseType.OneTime
    });
};
const pushQuantityDiscountSelectionEvent = (sku, name, price, discountedPrice, discountPercentage)=>{
    DataLayer.pushEvent({
        event: 'select_quantity_discount',
        ecommerce: {
            promotion_name: 'quantity discount',
            discount_percentage: discountPercentage,
            items: [
                {
                    item_id: sku,
                    item_name: name,
                    price: calcPrice(price),
                    discount: calcPrice(discountedPrice)
                }, 
            ]
        }
    });
};

export { pushEventToDataLayer, pushPdpEventToDataLayer, pushQuantityDiscountSelectionEvent, pushTabClickEvent };
//# sourceMappingURL=data-layer.js.map
